import React from 'react';
import './Services.css';
import Card from '../common/Card';
import {connect} from 'react-redux';

class Services extends React.Component{
    
    constructor(props){
        super(props);
        this.state={}
    }

    onSelectChange= (e) =>{
        const value= e.target.value;
        this.setState({
            value
        });
    }

    render(){
        const {services , discount ,exclusive} =this.props;
        const filteredData= this.state.value==='exclu'?exclusive:
                            this.state.value==='discount'?discount:services
        return(
        <div className="services">
            <div className="services-banner lemo-font"><h1>خدمات المركز</h1></div>
            <div className="label-center ">
            <select name="sevrices" id="select" className="cairo-font" onChange={this.onSelectChange}>
                <option value="all">الكل</option>
                <option value="exclu"> حصرى </option>
                <option value="discount"> خصومات </option>
            </select>
            </div>
            <div className="services-container wrapper">
                {filteredData.map((service,i)=><Card {...service}/>)}
            </div>        
        </div>
        );
    }
}
export default connect(mapStateToProps) (Services);


function mapStateToProps(state,props){
    return{
      services:state.services,
      discount:state.services.filter(service => service.discount),
      exclusive:state.services.filter( service => service.exclusive)
    }
}




// WEBPACK FOOTER //
// ./src/components/services/Services.js